import React, { useState, useEffect } from 'react';
import Toast from './Toast';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles
const FaithStatementSettings = ({ mySettings }) => {
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const [faithstatement, setFaithstatement] = useState('');
    const [id, setId] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL || 'http://45.194.3.128:4000/api/admin/';


    const handleCancel = () => {
        setFaithstatement('');
    };


    const handleSave = async () => {

        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}update-faithstatement-settings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                faith_statement: faithstatement,
                settingId: id,
            }),
        });

         const data = await response.json();

            if (!response.ok || data.success === false) {

                if (data.message === 'Invalid token') {
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                    return;
                }

                    setToast({ open: true, message: `Error saving settings: ${data.message}`, severity: "error" });
            }

            setToast({ open: true, message: "Settings saved successfully!", severity: "success" });
            setTimeout(() => window.location.reload(), 1000);
       
    };

    useEffect(() => {
        if (mySettings && mySettings.length > 0) {
            const orgSettings = mySettings[0]; // first org's settings
            setFaithstatement(orgSettings.faith_statement || '');
            setId(orgSettings.id || null);
        }
    }, [mySettings]);

    return (
        <div style={{ border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 12, padding: 16, background: 'rgba(255, 255, 255, 0.05)', backdropFilter: 'blur(20px)', boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)', color: '#FFFFFF' }}>


            <ReactQuill
                theme="snow"
                value={faithstatement}
                onChange={(content) => setFaithstatement(content)}
            />


            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <button
                    style={{ background: '#1976d2', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: 4, marginRight: 10 }}
                    onClick={handleSave}
                >
                    Save
                </button>
                <button
                    style={{ background: '#757575', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: 4 }}
                    onClick={handleCancel}
                >
                    Cancel
                </button>
            </div>
            <Toast toast={toast} setToast={setToast} />
        </div >
    );
};

export default FaithStatementSettings;